<template>
	<section class="social-wrapper">
		<div class="container" >
			<div class="page-top">
				<div class="title">寻找答案激发灵感</div>
				<div style="position: relative;">
					<el-input class="input-key" placeholder="请输入关键字搜索" v-model="keyword" @blur="filterShow=false" @focus="filterShow=true" @input="toFilterData" >
					    <i slot="prefix" class="el-input__icon el-icon-search"></i>
					</el-input>
					<div class="filter-wrapper" v-if="filterShow">
						<div class="item-title" v-for="item in filterList" v-html="item.title"></div>
						<div class="nodata" v-if="filterList.length==0">暂无相关数据</div>
					</div>
				</div>
				<div class="active-image">
					<el-image :src="require('@/assets/activity-image.png')" fit="contain">
						<div slot="error" class="image-slot">
							<i class="el-icon-picture-outline"></i>
						</div>
					</el-image>
				</div>
			</div>
			<el-tabs class="tab-container" v-model="activeName" @tab-click="handleClick">
			    <el-tab-pane v-for="item in typeList" :label="item.label" :name="item.id">
					
				</el-tab-pane>
			</el-tabs>
			<div class="subtype" v-if="typeList.length>0 && activeName == typeList[0].id">
				<div class="item" v-for="item in subType" 
				:class="{'active':item.id == typeId}"
				@click="handleChange(item.id)"
				>{{item.typeName}}</div>
			</div>
			<div class="list-container">
				<div class="list-item" v-for="item in list">
					<div class="item-content" @click="todetail(item.id)">
						<div class="title" :style="typeId !== '1' && typeId !== '2'?'width:100%':'max-width: calc(100% - 105px);'">{{item.title}}</div>
						<div class="tag1" v-if="typeId == '1'">官方动态</div>
						<div class="tag2" v-if="typeId == '2'">技术交流</div>
						<div class="abstrc" style="-webkit-box-orient: vertical;">{{item.description}}</div>
						<div class="tagList" v-if="typeId !== '1' && typeId !== '2'">
							<span class="tag" v-for="val in item.tagArray">{{val.tagName}}</span>
						</div>
						<div class="create" >
							<span class="username" v-if="item.postUserInfo">{{item.postUserInfo.nickname}}</span>
							<span class="publishDate">{{item.createDate}}</span>
							<span class="readNum"><i class="iconfont icon-chakan"></i>{{item.readNum>1000?item.readNum>10000?(item.readNum/10000).toFixed(1)+'w':(item.readNum/1000).toFixed(1)+'k':item.readNum}}</span>
						</div>
					</div>
					<div class="image-wrapper">
						<el-image :src="item.descImages" fit="fill">
	
						</el-image>
					</div>
				</div>
				<el-pagination
					:hide-on-single-page="true"
				    layout="prev, pager, next"
					@current-change="handleCurrentChange"
				    :total="total">
				  </el-pagination>
				<el-empty v-if="total == 0" :image-size="200"></el-empty>
			</div>
			<div class="sidebar">
				<div class="side-item">
					<div class="release-title"><el-image :src="require('@/assets/lihua.png')" fit="contain"></el-image> 欢迎来到欢软社区 !</div>
					<div class="desc"><i class="iconfont icon-duigou"></i>遇到困难？来提问！</div>
					<div class="desc"><i class="iconfont icon-duigou"></i>想学技巧？来看经验！</div>
					<div class="desc"><i class="iconfont icon-duigou"></i>想吐槽？来反馈！</div>
					<el-button class="release-btn" type="warning" size="medium" @click="publishTopic">发帖</el-button>
				</div>
				<div class="side-item">
					<div class="title">热门话题 <span class="btn" :class="{'change-btn':ischange}" @click="toggleChange" v-if="topicList.length>5"><i class="el-icon-refresh-right"></i>换一换</span></div>
					<div class="topic" v-for="(item,index) in topicList" :style="{'display':isToggle?index>=5 ?'none':'block':index<5 ?'none':'block'}">
						<span class="num" :class="{'top1':index==0,'top2':index==1,'top3':index==2}">{{index+1}}</span>
						<span class="topic-title" @click="todetail(item.id)">{{item.title}}</span>
					</div>	
				</div>
				<div class="side-item">
					<div class="title">热门标签</div>
					<div class="tagList">
						<span class="tag" v-for="val in tagArray" @click="tagId = val.id;getDatalist()">{{val.tagName}}</span>
					</div>	
				</div>
				<div class="side-item">
					<div class="title">动态通知</div>
					<div class="steps">
						<div class="step-item" v-for="(item,index) in stpeList">
							<div class="icon-bg" :class="{'active':index==0}">
								<div class="icon-circle"></div>
							</div>
							<div class="step-content">
								<div class="date">{{item.createDate.slice(0,19)}}</div>
								<div class="step-title">{{item.title}}</div>
								<div class="step-btn" @click="todetail(item.id)">立即查看&gt;&gt;</div>
							</div>
							<div class="liner" v-if="index < stpeList.length-1"></div>
						</div>
					</div>
				</div>
				<div class="side-item">
					<div class="title">公众号</div>
					<el-image class="qrcode" :src="require('@/assets/qrcode.jpg')" fit="contain"></el-image>
					<div class="tips">关注微信公众号，订阅每周资讯</div>
				</div>
				<div class="active-image">
					<el-image :src="require('@/assets/activity-image.png')" fit="contain">
						<div slot="error" class="image-slot">
							<i class="el-icon-picture-outline"></i>
						</div>
					</el-image>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { getTopicType,getTopicList,gethotTopic,getNotification,hotTag } from '@/api/social/index'
import { toLogin } from '@/api/isLogin'
import { getIsTrial, getToken } from '@/utils/auth'
export default {
    data() {
      return {
        activeName: '',
		keyword: '',
		tagId: '',
		total: 0,
		page: 1,
		list:[],
		typeList:[],
		subType:[],
		ischange:false,
		isToggle: true,
		stpeList:[],
		topicList:[],
		filterList:[],
		filterShow: false
      };
    },
    methods: {
      handleClick(tab, event) {
        this.activeName = tab.name;
		this.typeList.forEach((item)=>{
			if(item.id == tab.name){
				if(item.children){
					this.typeId = this.subType[0].id
				}else{
					this.typeId = tab.name
				}
			}
		})
		
		this.getDatalist()
      },
	  getDifferTime(date){
		var publishDate = new Date(date)  
		var currentDate = new Date()  
		if(publishDate.getFullYear()<currentDate.getFullYear()){
			if(currentDate.getFullYear()-publishDate.getFullYear()==1){
				if(publishDate.getMonth() == currentDate.getMonth()){
					return '发布于1年前'
				}else{
					return `发布于${12-publishDate.getMonth()+currentDate.getMonth()}月前`
				}
			}else{
				return '发布于1年前'
			}
			
		}else{
			if(publishDate.getMonth() == currentDate.getMonth()){
				if(publishDate.getDate() == currentDate.getDate()){
					return `发布于${currentDate.getHours()- publishDate.getHours()}小时前`
				}else{
					return `发布于${currentDate.getDate()- publishDate.getDate()}日前`
				}
			}else{
				return `发布于${currentDate.getMonth()-publishDate.getMonth()}月前`
			}
		}
	  },
	  handleChange(id){
		this.typeId = id 
		this.getDatalist()
	  },
	  todetail(id){
	  	this.$router.push({path:'/social/detail/'+id})
	  },
	  publishTopic(){
		  if(getToken()){
		  	this.$router.push('/social/form')
		  }else{
		  	toLogin(this)
		  }
	  },
	  toggleChange(){
		this.ischange = true
		this.isToggle = !this.isToggle
		setTimeout(() => {
		  this.ischange = false;
		}, 500); 
	  },
	  async getHotTag(){
	  	const res = await hotTag()
	  	if (res.code === 0) {
	  		this.tagArray = res.data
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	  },
	  async getTypeData(){
	  	const res = await getTopicType()
	  	if (res.code === 0) {
	  		this.typeList = res.data.list
			this.activeName = this.typeList[0].id
			this.subType = this.typeList[0].children
			this.subType.unshift({id:'',typeName:'全部'})
			if(!this.typeId){
				this.typeId = this.subType[0].id
			}
	  		this.getDatalist()
			this.page = 1
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	  },
	  handleCurrentChange(val){
		this.page = val
	  	this.getDatalist()
	  },
	  async toFilterData(){
		if(this.keyword){
			const res = await getTopicList({page:this.page,limit:10,keyword:this.keyword})
			if (res.code === 0) {
				this.filterList = res.data.list
			} else {
			  this.$message.error(res.msg)
			}
		}else{
			this.filterList = []
		}
	  },
	  async getDatalist(){
	  	const res = await getTopicList({page:this.page,limit:10,typeId:this.typeId,tagId:this.tagId})
	  	if (res.code === 0) {
	  		this.list = res.data.list
	  		this.total = res.data.total
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	  },
	  async hotTopic(){
	  	const res = await gethotTopic()
	  	if (res.code === 0) {
	  		this.topicList = res.data
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	  },
	  async notificationList(){
	  	const res = await getNotification()
	  	if (res.code === 0) {
	  		this.stpeList = res.data
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	  }
    },
	mounted(){
		this.getTypeData()
		this.hotTopic()
		this.notificationList()
		this.getHotTag()
		this.typeId = this.$route.params.typeId
		this.tagId = this.$route.params.tagId
		window.scrollTo({top:0})
	}
}
</script>

<style lang="scss" scoped>
.social-wrapper{
	background-image: url('../../assets/shequ-bg.png');
	background-repeat: no-repeat;
	background-size: 100% 300px;
	margin: 0;
	padding-top: 80px;
	.container{
		max-width: 1400px;
		width: 80vw;
		margin: 0 auto;
		.page-top{
			padding: 30px 0 50px;
			position: relative;
			.active-image{
				position: absolute;
				top: 25px;
				right: 0;
				.el-image{
					width: 270px;
				}
			}
			.title{
				font-size: 32px;
				font-weight: 800;
				margin: 20px 0;
			}
			.input-key{
				border-radius: 40px;
				max-width: 420px;
				/deep/.el-input__prefix{
					left: 12px;
					font-size: 18px;
				}
				/deep/.el-input__inner{
					border-radius: 20px;
					padding-left: 40px;
					border: none;
				}
			}
			.filter-wrapper{
				width: 420px;
				position: absolute;
				top: 45px;
				background-color: #fff;
				box-shadow: 0 0 10px rgba(0,0,0,.1);
				padding: 15px 25px;
				border-radius: 8px;
				box-sizing: border-box;
				z-index: 99;
				.item-title{
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					margin: 8px 0;
				}
				.nodata{
					color: #A1A7B0;
					text-align: center;
					font-size: 14px;
				}
			}
		}
		.tab-container{
			margin: 50px auto 20px;
			/deep/.el-tabs__nav-wrap::after{
				// background-color: unset;
				height: 1px;
			}
			/deep/.el-tabs__active-bar{
				width: 25px !important;
				margin-left: 25px;
				background-color: #FF842E;
			}
			/deep/.el-tabs__item{
				font-size: 18px;
				font-weight: 800px;
				&.is-active{
					color: #FF842E;
				}
				&:hover{
					color: #FF842E;
				}
			}
		}
		/deep/.el-pager li.active {
		    color: #FF842E;
		    cursor: default;
		}
		/deep/.el-pager li:hover {
		    color: #FF842E;
		}
		/deep/.el-pagination button:hover{
			color: #FF842E;
		}
		/deep/.el-image__error{
			height: 100px;
		}
		/deep/.el-pagination{
			text-align: center;
			margin: 20px 0;
		}
		.subtype{
			margin: 10px;
			.item{
				display: inline-block;
				cursor: pointer;
				font-size: 16px;
				background-color: #F5F5F5;
				width: 120px;
				height: 32px;
				line-height: 32px;
				border-radius: 20px;
				text-align: center;
				margin-right: 15px;
				&.active{
					background-color: #F6F1EE;
					color: #FF8632;
				}
			}
		}
		.list-item{
			cursor: pointer;
			margin-top: 20px;
			.item-content{
				display: inline-block;
				width: calc(100% - 200px);
				vertical-align: top;
				.abstrc{
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					-webkit-box-orient: vertical;
					text-overflow: ellipsis;
					white-space: normal;
				}
				.title{
					font-size: 18px;
					font-weight: 800;
					color: #292929;
					margin: 0 0 10px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					display: inline-block;
					&:hover{
						opacity: .82;
					}
				}
				.tag1,.tag2{
					background-color: #FFF2F2;
					color: #FE6060;
					font-size: 14px;
					padding: 2px 8px;
					border-radius: 3px;
					display: inline-block;
					vertical-align: top;
					margin-left: 30px;
				}
				.tag2{
					background-color: #F1F6FD;
					color: #74AFFF;
				}
				.abstrc{
					font-size: 16px;
					color: #596372;
				}
				.tagList{
					margin: 10px 0;
					.tag{
						background-color: #F1F6FD;
						margin-right: 10px;
						padding: 2px 8px;
						border-radius: 3px;
						color: #5989ee;
						font-size: 14px;
					}
				}
				.create{
					color: #A1A7B0;
					font-size: 14px;
					margin-top: 8px;
					span{
						margin-right: 30px;
					}
					.username{
						color: #596372;;
					}
					.readNum{
						.iconfont{
							margin-right: 5px;
						}
					}
				}
			}
			
		}
		.image-wrapper{
			display: inline-block;
			margin-left: 30px;
			.el-image{
				width: 170px;
				height: 120px;
				border-radius: 5px;
			}
		}
		.list-container{
			width: calc(100% - 300px);
			display: inline-block;
			vertical-align: top;
		}
		.sidebar{
			display: inline-block;
			vertical-align: top;
			margin-top: 20px;
			.active-image{
				.el-image{
					width: 270px;
					height: 180px;
					margin: 0 0 30px 30px;
					
				}
			}
			.side-item{
				width: 270px;
				box-sizing: border-box;
				padding: 24px;
				margin: 0 0 30px 30px;
				border-radius: 15px;
				box-shadow: 0 0 15px rgba(0,0,0, .05);
				background-color: #fff;
				.release-title{
					font-size: 20px;
					font-weight: 800;
					margin-bottom: 10px;
					.el-image{
						width: 24px;
						margin-right: 5px;
						vertical-align: text-top;
					}
				}
				.tagList{
					margin: 10px 0;
					.tag{
						background-color: #F1F6FD;
						margin-right: 15px;
						padding: 2px 8px;
						border-radius: 3px;
						color: #5989ee;
						font-size: 14px;
						cursor: pointer;
					}
				}
				.desc{
					color: #596372;
					font-size: 15px;
					.icon-duigou{
						color: #FF842E;
						font-size: 12px;
						margin-right: 16px;
					}
				}
				.release-btn{
					background-color: #FF842E;
					width: 100%;
					border-radius: 20px;
					margin-top: 20px;
				}
				.topic{
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					margin: 10px 0;
					.num{
						color: #BEBEC2;
						font-weight: 800;
						font-style: italic;
						margin-right: 10px;
						&.top1{
							color: #FE815F;
						}
						&.top2{
							color: #FEBC5F;
						}
						&.top3{
							color: #FEE35F;
						}
					}
					.topic-title{
						color: #525254;
						cursor: pointer;
					}
				}
				.title{
					font-size: 18px;
					font-weight: 800;
					color: #2B2B2B;
					margin-bottom: 15px;
				}
				.qrcode{
					margin: 20px auto;
					width: 80%;
					display: block;
				}
				.tips{
					font-size: 14px;
					color: #525254;
					text-align: center;
				}
				.btn{
					cursor: pointer;
					float: right;
					color: #AAAEB4;
					font-weight: 500;
					font-size: 14px;
					.el-icon-refresh-right{
						font-size: 20px;
						margin-right: 5px;
						vertical-align: bottom;
					}
				}
				.change-btn{
					.el-icon-refresh-right{
						transform:rotate(360deg);
						transition: all .5s;
					}
				}
				.steps{
					height: 230px;
					overflow-y: scroll;
				}
				.step-item{
					position: relative;
					margin-top: 10px;
					.icon-bg{
						display: inline-block;
						margin-right: 8px;
						margin-top: 5px;
						width: 10px;
						height: 10px;
						vertical-align: top;
						position: relative;
						&.active{
							background-color: #FFEBDD;
							border-radius: 50%;
							.icon-circle{
								background-color: #FF842E;
							}
						}
						.icon-circle{
							background-color: #AAAEB4;
							width: 5px;
							height: 5px;
							border-radius: 50%;
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%,-50%);
						}
					}
					.step-content{
						display: inline-block;
						width: calc(100% - 20px);
						.date{
							color: #AAAEB4;
							font-size: 13px;
						}
						.step-title{
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
						.step-btn{
							color: #64A6FF;
							font-size: 13px;
							cursor: pointer;
						}
					}
					.liner{
						width: 1px;
						height: 55px;
						background-color: #E4E6E8;
						position: absolute;
						top: 22px;
						left: 5px;
					}
				}
				
			}
		}
	}
}
</style>